import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Domicilio`

export function buscarTodas(idUsuario, tipoUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarDomicilio/${idUsuario}/${tipoUsuario}`)
}

export function insertar(domicilio) {
  return http.post(API_ENDPOINT, domicilio)
}

export function eliminarDomicilio(idUsuarioDomicilio) {
  return http.delete(`${API_ENDPOINT}/EliminarDomicilio/${idUsuarioDomicilio}`)
}

export function actualizarDomicilio(domicilio) {
  return http.put(API_ENDPOINT, domicilio)
}

export function BuscarPorPais(idPais) {
  return http.get(`${API_ENDPOINT}/BuscarPorPais/${idPais}`)
}

export function BuscarLocalidades(idProvincia) {
  return http.get(`${API_ENDPOINT}/BuscarLocalidades/${idProvincia}`)
}
